export interface ProductInfo {
	id: string;
	name: string;
}

export interface PerformanceCalculationRequest {
	defaultProductName: string;
	products: ProductInfo[];
	productType?: string | null;
}

export interface ComponentPerformance {
	productId: string;
	productName: string;
	componentType: string;
	performanceValue: number;
	normalizedScore: number;
	isDefault: boolean;
	percentageDifference: number;
}

export interface PerformanceCalculationResponse {
	components: ComponentPerformance[];
	defaultComponentName: string;
}

const API_BASE_URL = "/configure/api/performance";

export async function calculatePerformance(
	request: PerformanceCalculationRequest
): Promise<PerformanceCalculationResponse> {
	const response = await fetch(`${API_BASE_URL}/calculate`, {
		method: "POST",
		headers: {
			"Content-Type": "application/json",
		},
		body: JSON.stringify(request),
	});

	if (!response.ok) {
		throw new Error(`Performance calculation failed: ${response.statusText}`);
	}

	return response.json();
}